import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import "./ListTopButtonsAndSearch.scss";
import { commonAction } from "../../../../redux/features/commonSlice";
import { manageInvitesAction } from "../../../../redux/features/manageInvitesSlice";
import { CommonEnums } from "../../../../enums/common.enums";
import SearchIcon from "../../../../components/icons/SearchIcon";
import ResetIcon from "../../../../components/icons/ResetIcon";
import ListFilterButton from "../../buttons/ListFilterButton";

const ListTopButtonsAndSearch = ({
  add_btn_name,
  add_btn_link,
  reset_btn_link,
  placeholder,
  onChangeSearch,
  type,
}: {
  add_btn_name?: string;
  add_btn_link?: string;
  reset_btn_link: string;
  placeholder: string;
  onChangeSearch?: any;
  type: string;
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const resetFilter = () => {
    dispatch(commonAction?.resetFilter());
    dispatch(manageInvitesAction.setInvitesListReset());
    navigate(reset_btn_link, { replace: true });
    if (onChangeSearch) {
      onChangeSearch({ target: { value: "" } });
    }
  };

  const onClickInvite = () => {
    dispatch(manageInvitesAction.setInviteDialog());
  };

  const getButton = () => {
    if (!add_btn_name || !add_btn_link) return null;

    switch (type) {
      case CommonEnums.pageTypes?.properties?.key:
        return (
          <Link to={add_btn_link} className="send-invite-btn">
            {add_btn_name}
          </Link>
        );

      case CommonEnums.pageTypes?.manage_invites?.key:
        return (
          <button className="send-invite-btn" onClick={onClickInvite}>
            {add_btn_name}
          </button>
        );

      case CommonEnums.pageTypes?.agency_employee?.key:
        return (
          <Link to={add_btn_link} className="send-invite-btn">
            {add_btn_name}
          </Link>
        );

      case CommonEnums.pageTypes?.agent_employee?.key:
        return (
          <Link to={add_btn_link} className="send-invite-btn">
            {add_btn_name}
          </Link>
        );

      default:
        return null;
    }
  };

  return (
    <div className="list-top-buttons-and-search-container">
      <div className="search-contain">
        <div className="search-icon">
          <SearchIcon />
        </div>
        <input
          type="text"
          placeholder={placeholder}
          className="search-input"
          onChange={onChangeSearch}
        />
      </div>
      <div className="list-top-buttons-container">
        {/* <button className="list-top-filter-btn" onClick={resetFilter}>
          <div className="filter-icon">
            <ResetIcon />
          </div>
          <p> Reset Filters</p>
        </button> */}

        <ListFilterButton />
        {getButton()}
      </div>
    </div>
  );
};

export default ListTopButtonsAndSearch;
